import React, { FC, useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

import { useState } from "react";
import { HistoriesAffiliatesModal } from "./HistoriesAffiliatesModal";
import HistoriesAffiliatesSearch from "./HistoriesAffiliatesSearch";
import HistoriesAffiliatesTable from "./HistoriesAffiliatesTable";

const App = ({
  dispatch_info,
  dispatch_danger,
  dispatch_get_histories_affiliates,
  dispatch_put_markets_exchanges_id_cancel,
}) => {
  const ref = useRef();
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);
  useEffect(() => {
    // document.body.classList.toggle("login-page");
    // document.body.classList.add("color-default");
    // document.body.classList.toggle("color-default");
    // return function cleanup() {
    //   // document.body.classList.toggle("login-page");
    //   document.body.classList.toggle("color-default");
    // };
  }, []);

  const [searchHistoriesAffiliates, set_searchHistoriesAffiliates] = useState({
    _search: { page: 1, limit: 10 },
  });

  const [modalHistoriesAffiliates, set_modalHistoriesAffiliates] = useState(
    false
  );

  const histories_orderings = useSelector(
    (state) => state.reduce_get_histories_affiliates
  );


 


  const inLoading =
    histories_orderings.isLoading || !histories_orderings.histories;
  const data_tables = inLoading ? [] : histories_orderings.histories;

  const total_count = inLoading ? 0 : histories_orderings.count;



  return (
    <>
      {/* <div className="content"> */}
        {/* <div className="info info-horizontal ml-4">
          <div className="description">
            <h4 className="info-title">
              <img
                className="mr-3"
                alt="..."
                src={require("assets/svg/bank-check.svg")}
                width="30px"
              />
              {t("出金承認")}
            </h4>
            <p className="mb-1 ml-5">{t("出金承認を管理します")}</p>
          </div>
        </div> */}
        <HistoriesAffiliatesSearch
          inLoading={inLoading}
          searchHistoriesAffiliates={searchHistoriesAffiliates}
          set_searchHistoriesAffiliates={set_searchHistoriesAffiliates}
          dispatch_get={dispatch_get_histories_affiliates}
          total_count={total_count}
        />
        <HistoriesAffiliatesTable
          searchHistoriesAffiliates={searchHistoriesAffiliates}
          set_searchHistoriesAffiliates={set_searchHistoriesAffiliates}
          set_modalHistoriesAffiliates={set_modalHistoriesAffiliates}
          dispatch_put_markets_exchanges_id_cancel={
            dispatch_put_markets_exchanges_id_cancel
          }
          data_tables={data_tables}
          inLoading={inLoading}
        />
        <HistoriesAffiliatesModal
          inLoading={inLoading}
          modal={modalHistoriesAffiliates}
          set_modal={set_modalHistoriesAffiliates}
          close_modal={() => {
            // set_searchHistoriesAffiliates({ limit: 10, page: 1 });
            set_modalHistoriesAffiliates(false);
          }}
          searchHistoriesAffiliates={searchHistoriesAffiliates}
          set_searchHistoriesAffiliates={set_searchHistoriesAffiliates}
          searchHistoriesAffiliates={searchHistoriesAffiliates}
          // set_searchHistoriesAffiliates={set_searchHistoriesAffiliates}
          dispatch_info={dispatch_info}
          dispatch_danger={dispatch_danger}
          dispatch_put_markets_exchanges_id_cancel={
            dispatch_put_markets_exchanges_id_cancel
          }
        />
      {/* </div> */}
    </>
  );
};

export default App;
